import React, { useState } from "react";
import DropDown from "../elements/dropDown";
import PoslovniProcessOwnerTable from "../poslovniProcesiOwnerTable";
import VersionHistory from "../admin/versionHistory";
import "./procedureDocumentation.css";

export default function ProcedureDocumentation({
  procedure,
  mapa,
  employees,
  designations,
  organizationUnits,
  disabled,
  onChangeProcedureField,
  onChangeResponsibilityRow,
  onAddResponsibilityRow,
  onRemoveResponsibilityRow,
  onChangeProcedurePreparedBy,
  onChangeProcedureControlledBy,
  onChangeProcedureApprovedBy,
  onChangeProcedurePreparedAt,
  onChangeProcedureControlledAt,
  onChangeProcedureApprovedAt,
}) {
  const [showVersionHistory, setShowVersionHistory] = useState(false);

  if (!procedure) return null;

  // BUG-21: ZAPOSLENI kolona treba da pokaže samo ime i prezime,
  // a ne "ime prezime - radno_mesto" (radno mesto je u zasebnoj koloni).
  const employeesShort = (employees || []).map((e) => ({
    ...e,
    name: `${e.first_name || ""} ${e.last_name || ""}`.trim(),
  }));

  const readOnlyFields = [
    {
      label: "PUN NAZIV ORGANIZACIJE",
      value: mapa?.company_name || "",
    },
    {
      label: "ORGANIZACIONA JEDINICA",
      // puna putanja (sektor – RJ – služba) kada je backend vrati, inače naziv jedinice
      value:
        mapa?.business_process_list?.organization_unit_path ||
        mapa?.business_process_list?.organization_unit_name ||
        "",
    },
    {
      label: "ŠIFRA PROCESA",
      value: procedure?.code || "",
    },
    {
      label: "ŠIFRA ORGANIZACIONE JEDINICE",
      value: mapa?.organization_unit_code || "",
    },
    {
      label: "RUKOVODILAC ORGANIZACIONE JEDINICE",
      value: mapa?.organization_unit_head || "",
    },
    {
      label: "VLASNIK PROCESA",
      value:
        mapa?.business_process_list?.business_process_owners
          ?.filter((o) => !o.del)
          .map((o) => `${o.first_name} ${o.last_name}`)
          .join(", ") || "",
    },
    {
      label: "NAZIV PROCESA",
      value: mapa?.business_process_list?.name || "",
    },
    {
      label: "CILJ PROCESA",
      value: mapa?.process_goal || "",
    },
  ];

  const responsibilityRows = procedure.responsibility_authorization || [];

  return (
    <div className="procedure-doc-section">
      <div
        style={{
          textAlign: "center",
          color: "var(--mainColor)",
          fontWeight: "600",
          margin: "20px 0 10px 0",
          fontSize: "14px",
        }}
      >
        DOKUMENTACIJA PROCEDURE -{" "}
        <span style={{ textDecoration: "underline" }}>
          {procedure?.name || ""}
        </span>
      </div>

      {readOnlyFields.map((field, idx) => (
        <div className="procedure-doc-field" key={idx}>
          <div className="procedure-doc-field-row">
            <div className="procedure-doc-field-label">{field.label}</div>
            <div className="procedure-doc-field-value">{field.value}</div>
          </div>
        </div>
      ))}

      <div className="procedure-doc-field">
        <div className="procedure-doc-field-row">
          <div className="procedure-doc-field-label">VERZIJA</div>
          <div className="procedure-doc-field-value" style={{ display: "flex", gap: "10px", alignItems: "center" }}>
            <input
              className="procedure-doc-input"
              value={procedure.version || mapa?.version || "1.0"}
              onChange={(e) => onChangeProcedureField("version", e.target.value)}
              readOnly={disabled}
              placeholder="npr. 1.0"
            />
            {procedure.id && (
              <button
                type="button"
                className="add-btn-large"
                title="Istorija verzija procedure"
                style={{ fontSize: "11px", padding: "2px 8px", whiteSpace: "nowrap" }}
                onClick={() => setShowVersionHistory(true)}
              >
                ISTORIJA VERZIJA
              </button>
            )}
          </div>
        </div>
      </div>

      {showVersionHistory && procedure.id && (
        <VersionHistory
          entityType="procedure"
          entityId={procedure.id}
          onClose={() => setShowVersionHistory(false)}
        />
      )}

      <div className="procedure-doc-field">
        <div className="procedure-doc-field-row">
          <div className="procedure-doc-field-label">OBLAST PROCEDURE</div>
          <div className="procedure-doc-field-value">
            <DropDown
              list={organizationUnits || []}
              onChange={(value) => {
                onChangeProcedureField("procedure_area", value.value.name);
                onChangeProcedureField("procedure_area_id", value.value.id);
                onChangeProcedureField("procedure_area_level", value.value.level);
              }}
              isMulti={false}
              selectedValue={procedure.procedure_area || ""}
              disabled={disabled}
              dropDownStyle={{ width: "100%" }}
            />
          </div>
        </div>
      </div>

      {/* Svrha i cilj procedure i Područje primene: slobodan tekst procedure
          (nije cilj procesa mape niti organizaciona jedinica iz OBLASTI) */}
      <div className="procedure-doc-field">
        <div className="procedure-doc-field-row">
          <div className="procedure-doc-field-label">SVRHA I CILJ PROCEDURE</div>
          <div className="procedure-doc-field-value">
            <textarea
              className="procedure-doc-textarea"
              value={procedure.purpose_and_goal || ""}
              onChange={(e) =>
                onChangeProcedureField("purpose_and_goal", e.target.value)
              }
              readOnly={disabled}
              placeholder={disabled ? "" : "Svrha i cilj ove procedure"}
            />
          </div>
        </div>
      </div>

      <div className="procedure-doc-field">
        <div className="procedure-doc-field-row">
          <div className="procedure-doc-field-label">PODRUČJE PRIMENE</div>
          <div className="procedure-doc-field-value">
            <textarea
              className="procedure-doc-textarea"
              value={procedure.scope_of_application || ""}
              onChange={(e) =>
                onChangeProcedureField("scope_of_application", e.target.value)
              }
              readOnly={disabled}
              placeholder={
                disabled ? "" : "Gde se procedura primenjuje i na koga se odnosi"
              }
            />
          </div>
        </div>
      </div>

      <div className="procedure-doc-field">
        <div className="procedure-doc-field-row">
          <div className="procedure-doc-field-label">ODGOVORNOST I OVLAŠĆENJE</div>
          <div
            className="procedure-doc-field-value"
            style={{ flexDirection: "column", padding: "5px" }}
          >
            <div className="resp-auth-table">
              <div
                className="resp-auth-row"
                style={{
                  fontWeight: "600",
                  borderBottom: "1px solid var(--mainColor)",
                  fontSize: "12px",
                }}
              >
                <div className="resp-auth-cell">ZAPOSLENI</div>
                <div className="resp-auth-cell">RADNO MESTO</div>
                {!disabled && <div style={{ width: "30px" }}></div>}
              </div>
              {responsibilityRows.map((row, idx) => {
                // tekst odgovornosti iz uvoza (bez veze sa zaposlenim/radnim
                // mestom) prikazuje se samo za čitanje i čuva se nepromenjen
                const description = String(row?.description || "").trim();
                return (
                  <div className="resp-auth-entry" key={idx}>
                    <div className="resp-auth-row">
                      <div className="resp-auth-cell">
                        <DropDown
                          list={employeesShort}
                          onChange={(value) =>
                            onChangeResponsibilityRow(idx, "employee", value)
                          }
                          isMulti={false}
                          selectedValue={row.employee_name || ""}
                          disabled={disabled}
                          fontSize={12}
                          paddingLeft={0}
                        />
                      </div>
                      <div className="resp-auth-cell">
                        <DropDown
                          list={designations || []}
                          onChange={(value) =>
                            onChangeResponsibilityRow(idx, "designation", value)
                          }
                          isMulti={false}
                          selectedValue={row.designation_name || ""}
                          disabled={disabled}
                          fontSize={12}
                          paddingLeft={0}
                        />
                      </div>
                      {!disabled && (
                        <button
                          className="resp-auth-remove-btn"
                          onClick={() => onRemoveResponsibilityRow(idx)}
                        >
                          x
                        </button>
                      )}
                    </div>
                    {description && (
                      <div className="resp-auth-description">{description}</div>
                    )}
                  </div>
                );
              })}
            </div>
            {!disabled && (
              <button className="resp-auth-add-btn" onClick={onAddResponsibilityRow}>
                + Dodajte red
              </button>
            )}
          </div>
        </div>
      </div>

      <div className="procedure-doc-field">
        <div className="procedure-doc-field-row">
          <div className="procedure-doc-field-label">OSTALA DOKUMENTACIJA</div>
          <div className="procedure-doc-field-value">
            <textarea
              className="procedure-doc-textarea"
              value={procedure.other_documentation || ""}
              onChange={(e) =>
                onChangeProcedureField("other_documentation", e.target.value)
              }
              readOnly={disabled}
            />
          </div>
        </div>
      </div>

      <div className="procedure-doc-field">
        <div className="procedure-doc-field-row">
          <div className="procedure-doc-field-label">ZAKONI I PROPISI</div>
          <div className="procedure-doc-field-value">
            <textarea
              className="procedure-doc-textarea"
              value={procedure.laws_and_regulations || ""}
              onChange={(e) =>
                onChangeProcedureField("laws_and_regulations", e.target.value)
              }
              readOnly={disabled}
            />
          </div>
        </div>
      </div>

      <div className="procedure-doc-field">
        <div className="procedure-doc-field-row">
          <div className="procedure-doc-field-label">TERMINI I SKRAĆENICE</div>
          <div className="procedure-doc-field-value">
            <textarea
              className="procedure-doc-textarea"
              value={procedure.terms_and_abbreviations || ""}
              onChange={(e) =>
                onChangeProcedureField("terms_and_abbreviations", e.target.value)
              }
              readOnly={disabled}
            />
          </div>
        </div>
      </div>

      <div style={{ marginTop: "15px" }}>
        <PoslovniProcessOwnerTable
          employees={employees}
          preparedBy={procedure?.prepared_by}
          controlledBy={procedure?.controlled_by}
          approvedBy={procedure?.approved_by}
          preparedAt={procedure?.prepared_at}
          controlledAt={procedure?.controlled_at}
          approvedAt={procedure?.approved_at}
          onChangePreparedBy={onChangeProcedurePreparedBy}
          onChangeControlledBy={onChangeProcedureControlledBy}
          onChangeApprovedBy={onChangeProcedureApprovedBy}
          onChangePreparedAt={onChangeProcedurePreparedAt}
          onChangeControlledAt={onChangeProcedureControlledAt}
          onChangeApprovedAt={onChangeProcedureApprovedAt}
          disabled={disabled}
        />
      </div>
    </div>
  );
}

